import React, { useState } from 'react';
import { Box, FormControl, FormHelperText, InputAdornment, OutlinedInput } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { styles } from './styles';
import { useDebouncedCallback } from 'use-debounce';

export default function Search({
  idLabel,
  placeholder,
  setSearch,
  initialValue,
  helperText,
  onEnter
}: {
  idLabel: string;
  placeholder: string;
  setSearch: (query: string) => void;
  initialValue?: string;
  helperText?: React.ReactNode;
  onEnter?: () => void;
}) {
  const [tempSearch, setTempSearch] = useState(initialValue || '');
  const debouncedAPICall = useDebouncedCallback((searchQuery) => {
    setSearch(searchQuery);
  }, 600);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTempSearch(event.target.value);
    debouncedAPICall(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onEnter) {
      onEnter();
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <FormControl fullWidth>
        <OutlinedInput
          id={`${idLabel}-search`}
          sx={styles.searchInput}
          placeholder={placeholder}
          value={tempSearch}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          startAdornment={
            <InputAdornment sx={{ padding: '0px 0px 0px 14px' }} position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </Box>
  );
}
